import Functions from "@/utils/functions";
import Service from "../abstract/service";

export default class Colaborador extends Service {
  constructor() {
    super();

    this._colaboradoresRef = this._db.collection(
      `${this._prefix}-gruposEmpresas/${this._grupoPrincipal}/Colaboradores`
    );
    this._equipeRef = this._db.collection(
      `${this._prefix}-gruposEmpresas/${this._grupoPrincipal}/Empresas`
    );

    this._usuarios = this._db.collection("Usuarios");

    //this.getColaborador('gruposEmpresas/GrupoCometa/Colaboradores')
    // this.getColaborador('gruposEmpresas/GrupoCometa/empresas/02629089000185')
  }

  async getById(cpf) {
    try {
      let colaborador = null;

      this._loading.setLoading(true, "Carregando informações do Colaborador");
      const response = await this._colaboradoresRef
        .where("cpf", "==", cpf)
        .get();
      for (let doc of response.docs) {
        colaborador = doc.data();
      }
      return Promise.resolve(colaborador);
    } catch (error) {
      return Promise.reject(error);
    } finally {
      this._loading.setLoading(false);
    }
  }

  async getColaborador(doc) {
    let empresa = await this._db.doc(
      "gruposEmpresas/GrupoCometa/empresas/02629089000185"
    );
    let test = await this._db.doc(doc).isEqual(empresa);
  }

  /**
   * Retornar valores que contem as empresas informadas
   * @param {Array} arrayEmpresas
   */
  async getByEmpresas(arrayEmpresas, ativo = true) {
    try {
      const groupsEmpresas = Functions.dividirArray(arrayEmpresas, 10);
      let colaboradores = new Array();
      for (const group of groupsEmpresas) {
        const response = await this._colaboradoresRef
          .where("empresas", "array-contains-any", group)
          .where("ativo", "==", ativo)
          .get();

        if (!response.empty) {
          for (let doc of response.docs) {
            let colabData = doc.data();
            // let usuarioSnapShot = await this._usuarios.doc(colabData.cpf).get();
            // let usuarioData = usuarioSnapShot.exists
            // ? usuarioSnapShot.data()
            // : { apelido: colabData.apelido, telefone: colabData.telefone };
            colaboradores.push({
              ...colabData,
              apelido: colabData.apelido,
              telefone: colabData.telefone
            });
          }
        }
      }

      return Promise.resolve(colaboradores);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async getByCpf(cpf) {
    try {
      let colaborador = await this._colaboradoresRef
        .where("cpf", "==", cpf)
        .get();
      let col = colaborador.data();
      return Promise.resolve(col);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async getDocRefByCpf(cpf) {
    try {
      let colaborador = await this._colaboradoresRef.doc(cpf);
      return Promise.resolve(colaborador);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async getAll(ativo = true) {
    try {
      const response = await this._colaboradoresRef
        .where("ativo", "==", ativo)
        .get();

      let colaboradores = new Array();
      if (!response.empty) {
        for (let doc of response.docs) {
          colaboradores.push(doc.data());
        }
      }

      return Promise.resolve(colaboradores);
    } catch (error) {
      return Promise.reject(error);
    }
  }
  /* Lista todas equipes por empresas */
  async listAll(items, dat) {
    let colaboradores = new Array();
    let ativo = false;
    if (items.ativo === "Sim") {
      ativo = true;
    }

    try {
      this._loading.setLoading(true, "Carregando Colaboradores");
      for (let item of items.empresas) {
        const empresa = dat.find(element => element.cnpj === item);

        const response = await this._colaboradoresRef
          .where("empresas", "array-contains", empresa.cnpj)
          .where("ativo", "==", ativo)
          .get();

        if (!response.empty) {
          for (let doc of response.docs) {
            let colaborador = doc.data();

            colaboradores.push({
              id: doc.id,
              nomeEmpresa: empresa.nome,
              ...colaborador
            });
          }
        }
      }
      return Promise.resolve(colaboradores);
    } catch (error) {
      return Promise.reject(error);
    } finally {
      this._loading.setLoading(false);
    }
  }

  async updateAtivo(id, value) {
    try {
      this._loading.setLoading(true, "Atualizando Estado do Colaborador");

      const response = await this._colaboradoresRef
        .doc(id)
        .update({ ativo: value });
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    } finally {
      this._loading.setLoading(false);
    }
  }

  async updateColaborador(id, params) {
    try {
      this._loading.setLoading(true, "Atualizando Colaborador");
      const response = await this._colaboradoresRef.doc(id).update(params);
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    } finally {
      this._loading.setLoading(false);
    }
  }

  async updateColaboradorEmpresa(id, empresas) {
    try {
      this._loading.setLoading(true, "Atualizando Empresas do Colaborador");
      const response = await this._colaboradoresRef.doc(id).update({
        empresas: empresas
      });
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    } finally {
      this._loading.setLoading(false);
    }
  }

  async getColaboradoresEquipe2(cnpj, cpf) {
    //95288732191

    try {
      const colaborador = await this._colaboradoresRef

        .where("cpf", "==", cpf)
        .where("papel", "in", ["Supervisor", "Gerente", "Administrador", "Dev"])
        .get();
      let equipes = new Array();
      var colaboradores = [];
      if (colaborador.docs[0].data().papel === "Supervisor") {
        this._loading.setLoading(true, "Carregando Equipes");

        const response = await this._equipeRef
          .doc(cnpj)
          .collection("Equipes")
          .where("supervisor", "==", cpf)
          .get();

        for (let doc of response.docs) {
          let equipe = doc.data();

          equipes.push({
            id: doc.id,
            ...equipe
          });
        }
        for (let equipe of equipes) {
          for (let col of equipe.colaboradores) {
            if (col.colaborador !== null) colaboradores.push(col);
          }
        }
      } else {
        let col = await this.getByEmpresas([cnpj]);
        for (let c of col) {
          colaboradores.push(c);
        }
      }
      return Promise.resolve(colaboradores);
      // const response='.collection("Equipes")
      // .where("supervisor", "==", "95288732191")'
    } catch (error) {
      console.error(error);
      return Promise.resolve(error);
    } finally {
      this._loading.setLoading(false);
    }
  }
}
